'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.directive('validationMessage', function () {
    return {
      restrict: 'E',
      replace: true,
      template: require('./render.html'),
      scope: {
        show: '=',
        form: '=',
        model: '='
      }
    };
  });
  app
  // 正整数
  .directive('verifyPositiveInt', function () {
    return {
      restrict: 'A', require: 'ngModel', link: function link($scope, $element, $attr, ngModel) {
        ngModel.$validators.verifyPositiveInt = Validator.positiveInt;
      }
    };
  })
  // 正浮点数
  .directive('verifyPositiveDecimal', function () {
    return {
      restrict: 'A', require: 'ngModel', link: function link($scope, $element, $attr, ngModel) {
        ngModel.$validators.verifyPositiveDecimal = Validator.positiveDecimal;
      }
    };
  })
  // 邮箱格式
  .directive('verifyEmail', function () {
    return {
      restrict: 'A', require: 'ngModel', link: function link($scope, $element, $attr, ngModel) {
        ngModel.$validators.verifyEmail = Validator.email;
      }
    };
  })
  // 价格
  .directive('verifyPrice', function () {
    return {
      restrict: 'A', require: 'ngModel', link: function link($scope, $element, $attr, ngModel) {
        ngModel.$validators.verifyPrice = Validator.positiveDecimal;
      }
    };
  })
  // 手机号
  .directive('verifyMobile', function () {
    return {
      restrict: 'A', require: 'ngModel', link: function link($scope, $element, $attr, ngModel) {
        ngModel.$validators.verifyMobile = Validator.cellphone;
      }
    };
  })
  // 身份证
  .directive('verifyIdCard', function () {
    return {
      restrict: 'A', require: 'ngModel', link: function link($scope, $element, $attr, ngModel) {
        ngModel.$validators.verifyIdCard = Validator.idCard;
      }
    };
  })
  // 比较两个ngModel的值是否相等
  .directive('verifyEqualTo', function ($parse) {
    return {
      restrict: 'A', require: 'ngModel', link: function link($scope, $element, $attr, ngModel) {
        var anotherModel = $parse($attr.verifyEqualTo);
        ngModel.$validators.verifyEqualTo = function (value) {
          return value == anotherModel($scope).$viewValue;
        };
      }
    };
  })
  // 出厂日期
  .directive('productionDate', function () {
    return {
      restrict: 'A', require: 'ngModel', link: function link($scope, $element, $attr, ngModel) {
        ngModel.$validators.productionDate = function (value) {
          if (value === null || value === undefined || value.length) {
            return true;
          } else {
            value = value.toString();
            if (!Validator.positiveInt(value) || value.length !== 6) {
              return false;
            } else {
              var month = value.substr(4, 6);
              month = parseInt(month);
              if (month < 1 || month > 12) {
                return false;
              }
            }
          }
          return true;
        };
      }
    };
  });
  return app;
};

require('angular');

var _validator = require('../../../utils/validator');

var Validator = _interopRequireWildcard(_validator);

require('./index.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * angular 表单验证
 * 结合angular-messages
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/directives/validationMessage/index.js
// module id = 40
// module chunks = 0